export const AllLayers = `
    query allLayers {
        allLayers {
            nodes {
                layerId
                layername
                geoType
                type
            }
    }
}
`;
